/**
 * 投诉处理路由
 */
const ComplaintRouter = {
  path: 'complaint',
  name: 'Complaint',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Complaint/index')
}
export default ComplaintRouter
